module.exports = __webpack_public_path__ + "img/064.c38b8b97.png";